// namespace
window.Components = window.Components || {};

import domReady from '@wordpress/dom-ready';

(function($) {

  'use strict';

  function decompte() {

    const self = this,
        $cache = {};
    let clock;

    /**
     * Public constructor
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    self.initialize = function(target) {
        $cache.main = target;

        const interval = 1000; // 1 second
        // get time elements, scoped to this component's root
        const timerElement    = $cache.main.find(".countdown")[0];
        const yearElement     = $cache.main.find(".years")[0];
        const monthElement    = $cache.main.find(".months")[0];
        const dayElement      = $cache.main.find(".days")[0];
        const hourElement     = $cache.main.find(".hours")[0];
        const minElement      = $cache.main.find(".minutes")[0];
        const timer           = timerElement.dataset.timer+' 13:00';

        /* eslint-disable no-undef */
        // calculate difference between two times
        const eventTime = moment.tz(timer, "America/New_York");

        function render() {
            // recompute from source each tick to avoid drift
            const currentTime = moment.tz();
            const duration = moment.duration(Math.max(eventTime.diff(currentTime), 0));
            /* eslint-enable no-undef */

            yearElement.innerText = duration.years() < 10 ? '0'+ duration.years() : duration.years();
            monthElement.innerText = duration.months() < 10 ? '0'+ duration.months() : duration.months();
            dayElement.innerText = duration.days() < 10 ? '0'+ duration.days() : duration.days();
            hourElement.innerText = duration.hours() < 10 ? '0'+ duration.hours() : duration.hours();
            minElement.innerText = duration.minutes() < 10 ? '0'+ duration.minutes() : duration.minutes();

            if (duration.asMilliseconds() <= 0) {
                clearInterval(clock);
            }
        }

        timerElement.classList.remove("js-hidden");

        render();
        // loop to countdown every 1 second
        clock = setInterval(render, interval);
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  window.Components.decompte = decompte;

  domReady(() => {
    $('[data-component="decompte"]').each(function() {
      new window.Components.decompte($(this));
    });
  });

}(jQuery));